import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import NoSsr from "@material-ui/core/NoSsr";
import Slider from "@material-ui/lab/Slider";
import {withStyles} from "@material-ui/core/styles";
import {setOpacity} from "../../AC/set-opacity";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import OpacityIcon from "@material-ui/icons/OpacityOutlined";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const styles = {
  slider: {
    padding: `22px 0px`,
    width: `100px`
  },
  root: {
    padding: `12px 2px 12px 8px`,
    borderRadius: `3px`
  },
  track: {
    backgroundColor: `#838587`
  },
  thumb: {
    backgroundColor: `#838587`
  }
};

class Opacity extends React.Component {
  state = {
    opacity: this.props.selected ? this.props.selected.opacity * 100 : 100,
    anchorEl: null
  };
  static propTypes = {
    classes: PropTypes.object.isRequired,
    setOpacity: PropTypes.func,
    selected: PropTypes.object
  };
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (selected && JSON.stringify(selected) !== JSON.stringify(prevSelected)) {
      this.setStateFromObject(selected);
    }
  }
  handleChange = (_, value) => {
    const opacity = value / 100;
    this.setState({
      opacity: value
    });
    this.props.setOpacity(opacity);
  };
  setStateFromObject = (object) => {
    const {opacity} = object;
    this.setState({
      opacity: opacity * 100
    });
  };
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  render() {
    const {classes, selected} = this.props;
    const {opacity, anchorEl} = this.state;
    return (
      !!selected && (
        <NoSsr>
          <div className="panel-control__item">
            <Tooltip title="Прозрачность">
              <IconButton
                aria-owns={anchorEl ? `opacity-menu` : void 0}
                aria-haspopup="true"
                classes={{root: classes.root}}
                onClick={this.handleClick}
              >
                <OpacityIcon />
                <ArrowDropDownIcon />
              </IconButton>
            </Tooltip>
            <Menu
              id="opacity-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem>
                <Slider
                  classes={{
                    container: classes.slider,
                    track: classes.track,
                    thumb: classes.thumb
                  }}
                  value={opacity}
                  aria-labelledby="label"
                  onChange={this.handleChange}
                />
                <span className="opacity__value" style={{marginLeft: `10px`}}>
                  {opacity.toFixed()}%
                </span>
              </MenuItem>
            </Menu>
          </div>
        </NoSsr>
      )
    );
  }
}

export default withStyles(styles)(connect(null, {setOpacity})(Opacity));
